import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';

export type ToastType = 'error' | 'success';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

interface ToastState {
  toasts: Toast[];
}

const initialState: ToastState = {
  toasts: [],
};

function prepareToast(message: string) {
  return { payload: { id: crypto.randomUUID(), message } };
}

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showError: {
      reducer(state, action: PayloadAction<{ id: string; message: string }>) {
        state.toasts.push({
          id: action.payload.id,
          message: action.payload.message,
          type: 'error',
        });
      },
      prepare: prepareToast,
    },
    showSuccess: {
      reducer(state, action: PayloadAction<{ id: string; message: string }>) {
        state.toasts.push({
          id: action.payload.id,
          message: action.payload.message,
          type: 'success',
        });
      },
      prepare: prepareToast,
    },
    dismissToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const { showError, showSuccess, dismissToast } = toastSlice.actions;
export default toastSlice.reducer;

export const selectToasts = (state: RootState) => state.toast.toasts;
